<template>
    <footer-hero v-if="showLargeFooter" />
    <!-- Footer Section -->
    <footer class="bg-matt">
        <div class="mx-auto max-w-screen-xl px-4 py-4 sm:px-6 lg:px-8">
            <div class="sm:flex sm:items-center sm:justify-between">
                <div class="flex justify-center text-teal-600 sm:justify-start">
                    <a href="/">
                        <span class="font-aerial font-bold text-primary">docu</span>
                        <span class="font-aerial font-bold text-white">-vault</span>
                    </a>
                </div>
                <div class="flex items-center justify-center gap-5">
                    <p class="mt-4 text-center text-sm text-gray-500 lg:mt-0 lg:text-right">
                        <a href="/privacy-policy">Privacy Policy</a>
                    </p>
                    <p class="mt-4 text-center text-sm text-gray-500 lg:mt-0 lg:text-right">
                        <a href="/terms-of-service">Terms & Conditions</a>
                    </p>
                </div>
                <p class="mt-4 text-center text-sm text-gray-500 lg:mt-0 lg:text-right">
                    Copyright &copy; {{ new Date().getFullYear() }} Ajility Development LLC. All Rights Reserved.
                </p>
            </div>
        </div>
    </footer>
</template>

<script setup lang="ts">
import FooterHero from '@/Pages/Landing/Partials/FooterHero.vue'

defineProps({
    showLargeFooter: {
        type: Boolean,
        default: () => true,
    },
})
</script>

<style scoped lang="scss">
section {
    padding: 0 2rem;
}

section p {
    color: #222;
}

.subtitle {
    position: relative;
    border-radius: 50px;
}

.subtitle:before {
    content: '';
    display: inline-block;
    width: 30px;
    vertical-align: middle;
    height: 1px;
    position: absolute;
    top: 50%;
    left: -18%;
    transform: translate(-50%);
    background: #ff0000;
}

.text-white.subtitle:before {
    background: #fff;
}

@media (min-width: 1200px) {
    section {
        padding: 0 8rem;
    }
}
</style>
